import {IAction} from "@pg-mono/request-state";

export interface ISetBottomFixedElementHeight extends IAction {
    value: number | null;
}

export interface ISetPropertyBuyRewardBannerVisibility extends IAction {
    value: boolean;
}

export const SET_BOTTOM_FIXED_ELEMENT_HEIGHT = "ui/SET_BOTTOM_FIXED_ELEMENT_HEIGHT";
export const SET_PROPERTY_BUY_REWARD_BANNER_VISIBILITY = "ui/SET_PROPERTY_BUY_REWARD_BANNER_VISIBILITY";

export const setBottomFixedElementHeight = (value: number | null) => ({
    type: SET_BOTTOM_FIXED_ELEMENT_HEIGHT,
    value
});

export const setPropertyBuyRewardBannerVisibility = (value: boolean) => ({
    type: SET_PROPERTY_BUY_REWARD_BANNER_VISIBILITY,
    value
});

export type IUiActions = ISetBottomFixedElementHeight | ISetPropertyBuyRewardBannerVisibility;
